import React from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    Cell,
    Tooltip,
    CartesianGrid,
    XAxis,
    YAxis,
    Legend
} from 'recharts';

import { Container, ChartContainer } from './styles';

interface IBarChartProps {
    title: string;
    data: {
        descricao: string,
        janeiro: number,
        fevereiro: number,
        marco: number,
        abril: number,
        maio: number,
        junho: number,
        julho: number,
        agosto: number,
        setembro: number,
        outubro: number,
        novembro: number,
        dezembro: number,
    }[],
}


const BarChartBox: React.FC<IBarChartProps> = ({ title, data }) => (
    <Container>
        <span>{title}</span>
        <ChartContainer>
            <ResponsiveContainer>
                <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="descricao" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="janeiro" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="fevereiro" barSize={5} fill="#D49EB9" />
                    <Bar dataKey="marco" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="abril" barSize={5} fill="#D49EB9" />
                    <Bar dataKey="maio" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="junho" barSize={5} fill="#D49EB9" />
                    <Bar dataKey="julho" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="agosto" barSize={5} fill="#D49EB9" />
                    <Bar dataKey="setembro" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="outubro" barSize={5} fill="#D49EB9" />
                    <Bar dataKey="novembro" barSize={5} fill="#6D6A93" />
                    <Bar dataKey="dezembro" barSize={5} fill="#D49EB9" />                 
                </BarChart>
            </ResponsiveContainer>
        </ChartContainer>
    </Container>
);

export default BarChartBox;